import React from "react";
import { Form, Card, Input } from "antd/lib/index";
import { Field } from "formik";
import CustomInputComponent from "../../../ui/CustomInputComponent";

const GeneralInput = props => {
  const { handleChange, handleBlur, values } = props;
  return (
    <Card size="small" style={{ margin: 50, backgroundColor: "gray" }}>
      <React.Fragment>
        <Field
          label="Nivel"
          name={`nivel`}
          type={"number"}
          component={CustomInputComponent}
        />
        <Form.Item>
          <Input.TextArea
            rows={5}
            autosize={{ minRows: 5 }}
            type="text"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.descripcion}
            name="descripcion"
          />
        </Form.Item>
      </React.Fragment>
    </Card>
  );
};

export default GeneralInput;
